export async function fetchVendors() {
  const response = await fetch(`/api/vendor`);
  if (!response.ok) throw new Error('Failed to fetch coupon');
  return await response.json();
}
